/**
 * Shared calculation utilities for all Monamodi policy amendments
 *
 * This module provides common calculation functions used across different
 * amendment types (Manage Members, Change Plan, etc.)
 */

/**
 * Calculate total premium for a group of members
 * @param {Array} members - Array of member objects
 * @returns {Number} - Total premium in cents
 */
export const calculateGroupTotal = (members) => {
  if (!members || members.length === 0) return 0;
  return members.reduce((sum, member) => sum + (member.premium_amount_in_cents || 0), 0);
};

/**
 * Format premium amount in cents to currency display
 * @param {Number} amountInCents - Amount in cents
 * @returns {String} - Formatted amount (e.g., "79.00")
 */
export const formatPremium = (amountInCents) => {
  return ((amountInCents || 0) / 100).toFixed(2);
};

/**
 * Calculate premium totals for all member groups
 * @param {Object} groupedMembers - Object with nuclear, parents, extended arrays
 * @returns {Object} - Object with nuclearTotal, parentsTotal, extendedTotal, grandTotal in cents
 */
export const calculateAllGroupTotals = (groupedMembers) => {
  const nuclearTotal = calculateGroupTotal(groupedMembers.nuclear);
  const parentsTotal = calculateGroupTotal(groupedMembers.parents);
  const extendedTotal = calculateGroupTotal(groupedMembers.extended);
  const grandTotal = nuclearTotal + parentsTotal + extendedTotal;

  return {
    nuclearTotal,
    parentsTotal,
    extendedTotal,
    grandTotal
  };
};
